var src= document.currentScript.src;
var filename = src.substring(src.lastIndexOf('/')+1);
var str  = filename.split("?");

var id= Shopify.theme.id;
$.ajax({
url:'https://termsfy.com/admin/cartcon.php',
type:'GET',
data:{inputdata:id,filename:str[0]},
crossDomain:true,
success:function(res){
var data = JSON.parse(res);
if(data==id)
{
$("[name='checkout']").after("<p><input id='agree' type='checkbox'/>I agree with the terms and conditions</p>");
$('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
  if ($('#agree').is(':checked')) {
    $(this).submit();
  }
  else {
    alert("You must agree with the terms and conditions of sales to check out.");
    return false;
  }
});
      
}
}
});



